import { Button, Col, Form, Input, Row, notification } from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const LienComment = ({ lienId, onSuccess }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const updateLien = async (values) => {
		const lien = {
			comment: values.comment,
			emails: values.emails ? values.emails.map((item) => item.email) : [],
		};

		try {
			const url = api + `/lien/add/comment/${lienId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, lien);
			if (data.success) {
				openNotification("success", "Success", "Comment Added");
				setTimeout(() => {
					onSuccess();
					setLoadingButton(false);
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add lien comment"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoadingButton(true);
		updateLien(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
			>
				<Row gutter={16}>
					<Col span={24} xs={12}>
						<Form.Item
							label="Comment"
							name="comment"
							rules={[
								{
									required: true,
									message: "Comment is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Emails">
							<Form.List name="emails">
								{(fields, { add, remove }) => (
									<>
										{fields.map(({ key, name, ...restField }) => (
											<Row align={"center"} justify={"center"}>
												<Col span={20} key={key}>
													<Form.Item
														{...restField}
														name={[name, "email"]}
														style={{ width: "100%" }}
														rules={[
															{
																required: true,
																message: "Email is required",
															},
															{
																type: "email",
																message: "Email is invalid",
															},
														]}
													>
														<Input size="large" width={"100%"} />
													</Form.Item>
												</Col>
												<Col
													span={4}
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														height: 40,
													}}
												>
													<MinusCircleOutlined
														onClick={() => {
															remove(name);
														}}
													/>
												</Col>
											</Row>
										))}

										<Form.Item>
											<Button
												type="dashed"
												size="large"
												onClick={() => add()}
												block
												icon={<PlusOutlined />}
											>
												Add Email
											</Button>
										</Form.Item>
									</>
								)}
							</Form.List>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} sm={12} md={6}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Add comment
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
		</>
	);
};

export default LienComment;
